<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';

const router = useRouter();

const userStore = useUserStore();

onMounted(async () => {
    await userStore.fetchMe();
    if (!userStore.isLoggedIn) {
        router.replace({name: 'LoginPage'});
    }
});
</script>

<template>
    <router-view />
</template>
